// removed by extract-text-webpack-plugin
module.exports = {"textarea":"_2MB4i-0JbU6-Wyy6czTXLG","text":"_2AAaSLBZOxDLs7vMGVEiYx","checkbox":"_24dbY0m37nZmaZ_ZBsNIv","radio":"_3Kk-eEE5Cl0mUhYt9GYjND"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/form.css
// module id = 172
// module chunks = 0